export enum BraintreeLocalPaymentCancelledErrorCodes {
  LOCAL_PAYMENT_NOT_ENABLED = 'LOCAL_PAYMENT_NOT_ENABLED',
  LOCAL_PAYMENT_CANCELED = 'LOCAL_PAYMENT_CANCELED',
  LOCAL_PAYMENT_WINDOW_CLOSED = 'LOCAL_PAYMENT_WINDOW_CLOSED',
}

export const enum IdealDomId {
  BUTTON_LABEL = 'ideal-btn-label',
  BUTTON_DESC = 'ideal-btn-desc',
  BILLING_CONTAINER = 'ideal-billing-address-container',
  SELECTED_PAYMENT_METHOD = 'selected-payment-method',
  SELECTED_PAYMENT_FORM = 'selected-payment-form-container',
}
